import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { Accordion, Dropdown } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Application } from "../../app/models/enums";
import { useStore } from "../../app/stores/store";
import InventoryReportsSubMenu from "./InventoryReportsSubMenu";

export default observer(function ReportsDropdownMenu() {
  const { t } = useTranslation(["common", "users"]);
  const {
    userStore: { checkApplication },
    inventorySettingsStore: { inventorySettings },
  } = useStore();
  const [expanded, stayExpanded] = useState(false);
  const [active, setActive] = useState(false);

  const panels = [
    {
      key: "details",
      title: t("inventory.inventoryReports", { ns: "reports" }),
      content: {
        content: <InventoryReportsSubMenu />,
      },
      active: active,
    },
  ];

  return (
    <Dropdown
      vertical
      selection={true}
      placeholder={t("select_report", { ns: "reports" })}
      className="widerDropdownMenu"
      expanded={expanded}
    >
      <Dropdown.Menu>
        <Dropdown.Item
          id="reportsTotalSales"
          key={"totalSales"}
          as={Link}
          to={`/reports/totalSales`}
          text={t("total_sales.header", { ns: "reports" })}
          icon="dollar sign"
        />
        <Dropdown.Item
          id="reportsLaborSales"
          key={"laborSales"}
          as={Link}
          to={`/reports/laborSales`}
          text={t("labor_sales.header", { ns: "reports" })}
          icon="wrench"
        />
        <Dropdown.Item
          id="reportsPartSales"
          key={"partSales"}
          as={Link}
          to={`/reports/partSales`}
          text={t("part_sales.header", { ns: "reports" })}
          icon="car"
        />
        <Dropdown.Item
          id="reportsMiscCharges"
          key={"miscCharges"}
          as={Link}
          to={`/reports/miscCharges`}
          text={t("misc_charge_sales.header", { ns: "reports" })}
          icon="plus square outline"
        />
        <Dropdown.Item
          id="reportsTax"
          key={"tax"}
          as={Link}
          to={"/reports/tax"}
          text={t("tax.header", { ns: "reports" })}
          icon="percent"
        />
        <Dropdown.Item
          id="reportsPayType"
          key={"payType"}
          as={Link}
          to={`/reports/payType`}
          text={t("pay_type.header", { ns: "reports" })}
          icon="tags"
        />
        <Dropdown.Item
          id="reportsTechnician"
          key={"technician"}
          as={Link}
          to={`/reports/technician`}
          text={t("techs.header", { ns: "reports" })}
          icon="users"
        />
        <Dropdown.Item
          id="reportsVendor"
          key={"vendor"}
          as={Link}
          to={`/reports/vendor`}
          text={t("vendor.header", { ns: "reports" })}
          icon="dolly"
        />
        <Dropdown.Item
          id="reportsCardTransaction"
          key={"cardTransaction"}
          as={Link}
          to={`/reports/cardTransaction`}
          text={t("cc_transaction.header", { ns: "reports" })}
          icon="credit card outline"
        />

        {checkApplication(Application.AutomotiveExpert) && (
          <>
            {inventorySettings?.enableCoreTracking && (
              <Dropdown.Item
                id="coreTrackingReport"
                key={"coreTrackingReport"}
                as={Link}
                to={`/reports/coreTracking`}
                text={t("labels.coreTracking", { ns: "inventory" })}
                icon="recycle"
              />
            )}
            <Dropdown.Item
              id="AccountsReceivableReport"
              key={"AccountsReceivableReport"}
              as={Link}
              to={`/reports/AccountsReceivable`}
              text={t("accountsReceivable", { ns: "accountsReceivable" })}
              icon="folder open"
            />
            <Dropdown.Item
              id="AgingReport"
              key={"AgingReport"}
              as={Link}
              to={`/reports/AgingReport`}
              text={t("agingReport", { ns: "accountsReceivable" })}
              icon="book"
            />
            {inventorySettings?.isActive && (
              <Accordion
                panels={panels}
                className="accordionSubMenuStyling"
                onClick={(e: MouseEvent) => {
                  stayExpanded(true);

                  const classes = (e.target as Element).className;
                  if (classes.includes('title') || classes.includes('dropdown')) {
                    setActive(!active);
                    e.stopPropagation()
                  }
                }}
              />
            )}
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
});
